import { type WorkspaceTemplates } from "@repo/api";
import { useSettings } from "@repo/ui";

export const useWorkspaceTemplates = (): {
  workspaceTemplates: WorkspaceTemplates | undefined;
  isLoading: boolean;
} => {
  const { workspace_templates: workspaceTemplates, isLoadingSettings } =
    useSettings();

  return { workspaceTemplates, isLoading: Boolean(isLoadingSettings) };
};
